import React from 'react';
import { Box, Typography, FormControl, RadioGroup, FormControlLabel, FormLabel } from '@mui/material';
import { t } from 'i18next';
import BlueRadio from '../../../../../components/blueradio/BlueRadio';
import { theme } from '../../../../../theme/maintheme';

type MFAProps = {
  handleChange: any;
  MFAInfo: { typeMFA: string; enableMFA: boolean};
  isModal?: boolean;
};

const MFATypes = [
  {
    type: "mobile",
    lable: "mfa_mobile",
    helper: "mfa_mobile_helper",
  },
  {
    type: "email",
    lable: "mfa_email",
    helper: "mfa_email_helper",
  },
];

  
const MFA = (props: MFAProps) => {
  const { handleChange, MFAInfo, isModal } = props;
  
  return (
    <Box
      sx={{
        border: "1px solid #000",
        borderRadius: "12px",
        padding: theme.spacing(3),
        marginTop: theme.spacing(3)
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography variant="body2" fontWeight={"bold"} sx={{ mr: 1 }}>
          {t("MFAAuthentication")}
        </Typography>
      </Box>
      <FormControl component="fieldset" sx={{ my: 2, marginBottom: "15px" }}>
        <RadioGroup
          aria-labelledby="radio-role"
          name="MFA"
          row
          //@ts-nocheck
          value={MFAInfo?.enableMFA ?? false}
          onChange={handleChange}
        >
        <FormControlLabel
          value={false}
          label={t("OFF")}
          control={<BlueRadio onChange={handleChange} />}
        />
        <FormControlLabel
          value={true}
          label={t("ON")}
          control={<BlueRadio onChange={handleChange} />}
        />
      </RadioGroup>
      {MFAInfo?.enableMFA && (
          <>
            {!isModal && (
              <Typography variant="body2" fontWeight={"bold"} sx={{ mr: 1, mt: 2 }}>
                {t("mfa_selection.mfa_linked_mobile_accounts")}
              </Typography>
            )}
            <FormControl
              component="fieldset"
              sx={{ ...(isModal ? { mx: 1 } : { mt: 1 }), mb: 2 }}
            >
              {!isModal && (
                <FormLabel
                  id="mfa_choose"
                  sx={{
                    mb: 1,
                    color: "var(--kyocera-text-grey)",
                    fontSize: "inherit",
                  }}
                >
                  {t("mfa_selection.mfa_choose_info")}
                  <strong style={{ color: "red", marginRight: 0 }}>*</strong>
                </FormLabel>
              )}
              <RadioGroup
                aria-labelledby="radio-role"
                name="typeMFA"
                //@ts-nocheck
                value={MFAInfo?.typeMFA}
                onChange={handleChange}
              >
                {MFATypes.map((type) => (
                  <FormControlLabel
                    key={type.type}
                    value={type.type}
                    label={
                      <>
                        <Typography variant="body2">
                          {t(`mfa_selection.${type.lable}`)}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "var(--kyocera-text-grey)" }}
                        >
                          {t(`mfa_selection.${type.helper}${isModal ? "_modal" : ""}`)}
                        </Typography>
                      </>
                    }
                    sx={{
                      alignItems: "flex-start", // align radio to top
                      "& .MuiFormControlLabel-label": {
                        marginTop: "4px", // optional fine-tuning
                      },
                    }}
                    control={<BlueRadio onChange={handleChange} />}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </>
        )}
    </FormControl>
   </Box>
  )
}

export default MFA